// src/lib/emailPasswordAuth.js
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut
} from "firebase/auth";
import { doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { auth, db } from "../components/firebase";

import { sanitizeEmail, sanitizePassword } from "./sanitize";


function getFunctionsBase() {
  const forced = process.env.REACT_APP_CF_BASE;
  if (forced) return forced.replace(/\/+$/, "");
  // fallback: same origin functions proxy (if you have one)
  return "";
}

async function callOnUserCreated(user) {
  const base = getFunctionsBase();
  if (!base) return;

  const idToken = await user.getIdToken(true);
  const ref = localStorage.getItem("referral_code") || "";

  await fetch(`${base}/onUserCreated`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ ref }),
  }).catch(() => null);

  // optional: clear after attempt
  if (ref) localStorage.removeItem("referral_code");
}


// куда вести после клика по verify-письму
function getVerifyContinueUrl() {
  // важно: домен должен быть в Firebase Auth -> Authorized domains
  return `${window.location.origin}/verify-email`;
}

async function ensureUserDoc(user) {
  if (!user?.uid) throw new Error("No user uid");

  // роль по дефолту должна совпадать с Rules: client
  const payload = {
    uid: user.uid,
    email: user.email || null,
    role: "client",
    plan: "free",
    verified: !!user.emailVerified,
    authProviders: { email: true },
    updatedAt: serverTimestamp(),
    createdAt: serverTimestamp()
  };

  // merge: true чтобы не перезатирать существующее
  await setDoc(doc(db, "users", user.uid), payload, { merge: true });
}

async function markVerifiedInUserDoc(user) {
  if (!user?.uid) return;
  await updateDoc(doc(db, "users", user.uid), {
    verified: true,
    updatedAt: serverTimestamp()
  }).catch(() => {});
}

export async function signUpEmailPassword(emailRaw, passwordRaw) {
  const email = sanitizeEmail(emailRaw);
  const password = sanitizePassword(passwordRaw);

  const cred = await createUserWithEmailAndPassword(auth, email, password);

  // 1) создаём users/{uid} СРАЗУ (Rules это разрешают)
  await ensureUserDoc(cred.user);

  // 2) отправляем verification письмо (явно задаём continueUrl)
  await sendEmailVerification(cred.user, {
    url: getVerifyContinueUrl(),
    handleCodeInApp: false
  });

  // 3) метод
  localStorage.setItem("pp_auth_method", "email");

  return cred.user;
}

export async function loginEmailPassword(emailRaw, passwordRaw) {
  const email = sanitizeEmail(emailRaw);
  const password = sanitizePassword(passwordRaw);

  const cred = await signInWithEmailAndPassword(auth, email, password);

  // на всякий: док всегда должен быть
  await ensureUserDoc(cred.user);

  // если уже verified — проставим флаг в users
  await cred.user.reload();
if (cred.user.emailVerified) {
  await markVerifiedInUserDoc(cred.user);

  // ✅ backend sync + referral claim/reward
  await callOnUserCreated(cred.user);

  await cred.user.getIdToken(true);
}


  localStorage.setItem("pp_auth_method", "email");
  return cred.user;
}

export async function resendVerifyEmail() {
  const u = auth.currentUser;
  if (!u) throw new Error("Not authenticated");

  await sendEmailVerification(u, {
    url: getVerifyContinueUrl(),
    handleCodeInApp: false
  });
}

export async function logoutEmail() {
  localStorage.removeItem("pp_auth_method");
  await signOut(auth);
}
